import { Paper, Skeleton, Stack } from '@mui/material';

export default function NewsCardSkeleton() {
  return (
    <Paper
      variant='outlined'
      elevation={0}
      data-testid='news-card-skeleton'
      sx={{ paddingTop: 5, paddingBottom: 6, paddingX: 2 }}
    >
      <Stack direction='column'>
        <Skeleton variant='rectangular' height={60} />
        <Skeleton variant='rectangular' height={24} sx={{ marginY: 1.5 }} />
        <Skeleton variant='rectangular' height={24} />
      </Stack>
    </Paper>
  );
}
